import http from "./http-common";
import { getAuthToken } from "./authService";

const getDownloadUrl = async (sourceFileId) => {
  const token = await getAuthToken();
  return http.get(`/api/v1/source-files/${sourceFileId}/download-url`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getDownloadUrls = async (uploadMetadataId) => {
  const token = await getAuthToken();
  return http.get(`/api/v1/source-files/by-upload/${uploadMetadataId}/download-urls`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const SourceFileService = {
  getDownloadUrl,
  getDownloadUrls,
};

export default SourceFileService;
